import { put, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { ADD_FLASH_MESSAGE, dismissFlashMessage } from 'shared/actions/UnboundFlashMessageActions';

function* handleAddFlashMessage(action) {
  if (!action.sticky) {
    yield delay(action.delay);
    yield put(dismissFlashMessage({ id: action.id }));
  }
}

export default function* FlashMessagesSaga() {
  yield takeEvery(ADD_FLASH_MESSAGE, handleAddFlashMessage);
}
